import { ButtonHTMLAttributes, FC } from 'react'

import Icon from '../../../../components/style/Icon/Icon'

import './ButtonSchedule.scss'

interface ButtonScheduleProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    className?: string;
    text?: string;
}

const ButtonSchedule: FC<ButtonScheduleProps> = ({
    className = '',
    text,
    ...props
}) => (
    <button
        type="button"
        className={`button-schedule ${className}`}
        {...props}
    >
        <Icon className="button-schedule__icon" kind="exit" />

        {text}
    </button>
)

export default ButtonSchedule
